import { useLocation } from "react-router-dom";

const Layout = ({ children }) => {
  const location = useLocation();

  // Якщо Landing ("/"), то рендеримо без container
  const isLanding = location.pathname === "/";

  // Отримуємо ім'я компонента (для id)
  const pageId = children?.type?.name?.toLowerCase() || "default";

  return (
    <div id={pageId}>
      {isLanding ? (
        children
      ) : (
        <div className="container">{children}</div>
      )}
    </div>
  );
};

export default Layout;
